export default __webpack_public_path__ + "static/media/public_relation.f1903260.png";